<template>
  <div class="comContent">
    <div style="padding: 24px 0">
      <el-form ref="form-data" :model="form" :inline="false" label-width="150px" label-position="right" :rules="rules"
        style="text-align: left">
        <el-form-item prop="name" label="活动名称">
          <el-input v-model.tirm="form.name" style="width: 400px" placeholder="请输入" clearable size="small" show-word-limit
            maxlength="50" :disabled="isDisabled" />
        </el-form-item>
        <el-form-item prop="goodsFrom" label="商品来源">
          <el-radio-group v-model="form.goodsFrom" :disabled="isDisabled">
            <el-radio :label="0">平台添加</el-radio>
            <el-radio :label="1">商户添加</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item prop="pcImageUrl" label="PC活动图">
          <imgUpload v-model="form.pcImageUrl" :isEdit="isDisabled" :limit="1" style="position: relative; top: 0px" @onSuccessUpload="validateField('pcImageUrl')">
            <template slot="tip">
              <p class="el-upload__tip">
                用于商城PC落地页展示，支持扩展名 .jpg .png，1920*400px，大小不超过10M
              </p>
            </template>
          </imgUpload>
        </el-form-item>
        <el-form-item prop="appImageUrl" label="APP活动图">
          <imgUpload v-model="form.appImageUrl" :isEdit="isDisabled" :limit="1" style="position: relative; top: 0px" @onSuccessUpload="validateField('appImageUrl')">
            <template slot="tip">
              <p class="el-upload__tip">
                用于商城App、小程序落地页展示，支持扩展名 .jpg .png，750*280px，大小不超过10M
              </p>
            </template>
          </imgUpload>
        </el-form-item>
        <el-form-item prop="thumbnailUrl" label="活动缩略图">
          <imgUpload v-model="form.thumbnailUrl" :isEdit="isDisabled" :limit="1" style="position: relative; top: 0px" @onSuccessUpload="validateField('thumbnailUrl')">
            <template slot="tip">
              <p class="el-upload__tip">
                用于商户端活动列表展示，支持扩展名 .jpg .png，100*100px，大小不超过3M
              </p>
            </template>
          </imgUpload>
        </el-form-item>

        <el-form-item prop="date" label="活动时间">
          <el-date-picker style="width: 400px" v-model="form.date" value-format="yyyy-MM-dd HH:mm:ss"
            :picker-options="pickerOptions" :disabled="isDisabled" type="datetimerange" size="small" range-separator="-"
            start-placeholder="开始时间" end-placeholder="结束时间" :default-time="['00:00:00', '23:59:59']" />
        </el-form-item>
        <el-form-item label="活动说明" prop="description">
          <div class="wang-enduit">
            <wangEnduit ref="wangEnduit" :value="form.description" :is-clear="isClear" :isDisabled="isDisabled"
              @changeEndit="watchEndit" />
          </div>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="plain" @click="back">返回</el-button>
          <el-button size="small" type="primary" @click="save" :disabled="isDisabled"
            :loading="saveLoading">保存</el-button>
          <el-button size="small" type="primary" @click="saveSubmit" :disabled="isDisabled"
            :loading="saveLoading">提交</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import wangEnduit from "@/components/wangEnduit";
import {
  activityAdd,
  activityDetails,
  activityUpdate,
} from "@/api/platActivityManage";
import avater from "/public/img/default.png";
import imgUpload from "@/components/imgUpload";

export default {
  components: {
    imgUpload,
    wangEnduit,
  },
  props: {},
  data() {
    const validateDesc = (rule, value, callback) => {
      if (!this.form.description) {
        callback(new Error("请输入活动说明"));
      } else {
        callback();
      }
    };
    return {
      isClear: false, // 清除富文本编辑内容
      avater: avater,
      isDisabled: false,
      saveLoading: false,
      pickerOptions: {
        disabledDate(date) {
          // 如果没有后面的-8.64e7就是不可以选择今天的
          return date.getTime() < Date.now() - 8.64e7;
        },
      },
      form: {
        id: "",
        name: "", // 活动名称
        goodsFrom: '', // 商品来源：0平台添加 1 商户添加
        pcImageUrl: [], // PC活动图
        appImageUrl: [], // App活动图
        thumbnailUrl: [], // 活动缩略图
        status: "", // 	状态 0-草稿，1-待开始，2-已停止(保存-0，提交-1)
        date: [],
        description: "", // 活动说明
      },

      rules: {
        name: [{ required: true, message: "请填写活动名称", trigger: "blur" }],
        goodsFrom: [{ required: true, message: "请填写商品来源", trigger: ['change'] }],
        pcImageUrl: [
          { required: true, message: "请上传PC活动图", trigger: ['blur', 'change'] },
        ],
        appImageUrl: [
          { required: true, message: "请上传App活动图", trigger: ['blur', 'change'] },
        ],
        thumbnailUrl: [
          { required: true, message: "请上传活动缩略图", trigger: ['blur', 'change'] },
        ],
        date: [
          { required: true, message: "请选择活动时间", trigger: "change" },
        ],
        description: [
          {
            required: true,
            message: "请填写活动说明",
            trigger: ['blur', 'change'],
            validator: validateDesc,
          },
        ],
      },
    };
  },
  created() {
    if (this.$route.query.id) {
      this.form.id = this.$route.query.id;
      this.query();
    }
    if (this.$route.query.type && this.$route.query.type == "detail") {
      this.isDisabled = true;
    }
  },
  mounted() { },
  watch: {

  },
  methods: {
    async validateField(prop){
      await this.$nextTick()
      this.$refs['form-data'].validateField(prop)
    },
    query() {
      activityDetails(this.form.id).then((res) => {
        if (res && res.id) {
          const { startTime, endTime, pcImageUrl, appImageUrl, thumbnailUrl, ...form } = res;
          form.date = [startTime, endTime];
          this.form = {
            ...form,
            appImageUrl: appImageUrl.split(','),
            pcImageUrl: pcImageUrl.split(','),
            thumbnailUrl: thumbnailUrl.split(','),
          };
        }
      });
    },
    watchEndit(val) {
      // 监听富文本编辑传过来的数据
      this.form.description = val;
    },
    // 保存
    save() {
      this.submit("DRAFT");
    },
    // 新增、编辑
    saveSubmit() {
      this.$confirm(
        `商品参与活动的信息，一经提交无法更改，只能做下架操作，请您确认是否提交活动信息?`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          this.submit("PUBLISHED");
        })
        .catch(() => { });
    },
    getParams() {
      const { date, id, pcImageUrl, appImageUrl, thumbnailUrl, ...form } = this.form;
      const params = {
        ...form,
        pcImageUrl: pcImageUrl.join(','),
        appImageUrl: appImageUrl.join(','),
        thumbnailUrl: thumbnailUrl.join(',')
      }
      params.startTime = date?.[0] ?? "";
      params.endTime = date?.[1] ?? "";
      id && id !== '' && (params.id = id)
      return params
    },
    submit(status) {
      this.$refs["form-data"].validate((valid) => {
        if (valid) {
          this.saveLoading = true;
          const params = this.getParams()
          if (status == "PUBLISHED") {
            // 已发布的
            params.status = 1;
          } else {
            // 草稿
            params.status = 0;
          }
          const req = this.form.id ? activityUpdate : activityAdd;
          req(params).then((res) => {
            if (res) {
              this.$message.success("提交成功");
              this.back();
            } else {
              this.$message.error(res.msg);
            }
          }).finally(() => { this.saveLoading = false });
        }
      });
    },
    back() {
      this.$router.replace({
        path: "./platActivityManage-activityList",
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.wang-enduit {
  //  max-width: 1200px;
}
</style>
